import React from "react";

const StepItem = props => {
  return (
    <div className="booking-step-item" style={props.style}>
      {props.children}
    </div>
  );
};

export { StepItem };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/StepItem.js